import React from "react";
import { FormattedMessage } from "react-intl";

import Card from "../../components/Card";
import CardBody from "../../components/CardBody";
import CardTitle from "../../components/CardTitle";

import DetailsReportButton from "./DetailsReportButton";
import DetailsHitLevelChart from "./DetailsHitLevelChart";
import DetailsHitLevelTable from "./DetailsHitLevelTable";

import messages from "./detailsMessages";

class DetailsHitLevel extends React.PureComponent {
  state = {
    isOpen: true,
  };

  render() {
    const { data, creatingPdf, hasLikertQuestion } = this.props;
    const { isOpen } = this.state;

    return (
      <Card>
        <CardBody>
          <FormattedMessage {...messages.hitLevel}>
            {txt => (
              <CardTitle>
                {txt}
                <DetailsReportButton
                  isOpen={isOpen || creatingPdf}
                  onClick={() => this.setState({ isOpen: !isOpen })}
                />
              </CardTitle>
            )}
          </FormattedMessage>
          {(isOpen || creatingPdf) && (
            <React.Fragment>
              {data ? (
                <React.Fragment>
                  <DetailsHitLevelTable data={data} hasLikertQuestion={hasLikertQuestion} />
                  <DetailsHitLevelChart data={data} hasLikertQuestion={hasLikertQuestion} />
                </React.Fragment>
              ) : (
                <FormattedMessage {...messages.noData}>{txt => txt}</FormattedMessage>
              )}
            </React.Fragment>
          )}
        </CardBody>
      </Card>
    );
  }
}

export default DetailsHitLevel;
